export default __webpack_public_path__ + "static/media/homePageBanner.3c331ecb.jpg";